import { CircularProgress } from '@mgmresorts/mgm-ui';
import React from 'react';

export default function AuthPartnerLinkPage() {
  // If the user lands here, then they should already be logged in.
  // The Auth Provider will identify the logged in user, link their account, and then redirect them out.
  return (
    <div data-testid='route-/auth/partner-link'>
      <CircularProgress size={48} indeterminate aria-label='Loading' />
    </div>
  );
}
